import { AgentInterface, IdInterface } from '../data';

export abstract class AgentFactoryInterface {
    abstract build(code: IdInterface): AgentInterface;
}
